import { useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import { useModelMeshStore } from '../state/store'

const usePositionTargets = (targets: string[], stateId?: string) => {
  const addTargetPositions = useModelMeshStore(state => state.addTargetPositions)
  const removeTargetPositions = useModelMeshStore(state => state.removeTargetPositions)

  useLayoutEffect(() => {
    const uuid = stateId || v4()

    if (targets.length) {
      addTargetPositions(uuid, targets)
    }

    return () => removeTargetPositions(uuid)
  }, [addTargetPositions, targets, removeTargetPositions, stateId])
}

export default usePositionTargets
